import { tempoApi } from '@/lib/api/tempoApi';
import type { PlanPermission } from '@/lib/api/types/adaptive-planner/plan';

interface PlanPermissionsResponse {
  items: PlanPermission[];
}

export const getPlanPermissions = async ({
  planIds,
}: {
  planIds: number[];
}): Promise<PlanPermission[]> => {
  const params = new URLSearchParams({ planIds: planIds.join(',') });
  const url = `api/v1/adaptive-planner/plan-permissions?${params.toString()}`;

  const response = await tempoApi().get(url).json<PlanPermissionsResponse>();
  return response.items;
};
